import { UNFILED_ASSETS_ID, FOLDER_ID } from 'framework-listing-lib/internal/Folders/constants/folders';
import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
export function getSelectedAssetFolderId(selectedObjectOrObjects) {
  const crmObject = Array.isArray(selectedObjectOrObjects) ? selectedObjectOrObjects[0] : selectedObjectOrObjects;
  if (!crmObject) {
    return UNFILED_ASSETS_ID.toString();
  }
  const folderId = getPropertyValue(crmObject, FOLDER_ID);
  if (folderId === UNFILED_ASSETS_ID.toString() || folderId === '0' || !folderId) {
    return UNFILED_ASSETS_ID.toString();
  }
  return folderId;
}